import { Action, createReducer, on } from '@ngrx/store';
import * as actions from '../actions';
import { IEmployeeBusinessDetailResponse } from '../models/employee-business-detail.model';

export const biDetailsFeatureKey = 'biDetails';

export interface BusinessInfoDetialsState {
  loadBusinessInfoDetailsResponse: IEmployeeBusinessDetailResponse[];
  loadBusinessInfoDetailsFailure: any;
}

export const initialState: BusinessInfoDetialsState = {
  loadBusinessInfoDetailsResponse: undefined,
  loadBusinessInfoDetailsFailure: undefined
};

export const reducer = createReducer(
  initialState,

  on(actions.loadBiDetailsSuccess, (state, action) => ({
    ...state,
    loadBusinessInfoDetailsResponse: action.response
  })),
  on(actions.loadBiDetailsFailure, (state, action) => ({
    ...state,
    loadBusinessInfoDetailsFailure: action.error
  }))
);

export const getBusinessInfoDetails = (state: BusinessInfoDetialsState) => state.loadBusinessInfoDetailsResponse;
